import { GET_ALL_CHECKBOX, ADD_CHECKBOX, UPDATE_CHECKBOX } from '../types'

const INITIAL_STATE = {
  allCheckbox: [],
  addCheckbox: [],
  updateCheckbox: [],
}

const checkboxReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_CHECKBOX:
      return {
        ...state,
        allCheckbox: payload,
      }
    case ADD_CHECKBOX:
      return {
        ...state,
        addCheckbox: payload,
      }
    case UPDATE_CHECKBOX:
      return {
        ...state,
        updateCheckbox: payload.id,
      }
    default:
      return state
  }
}

export default checkboxReducer
